import React from "react"
import { EventData, GuestData } from "./utils/badgeDataResolver"
import {
  BadgeSelectionProvider,
} from "./contexts/BadgeSelectionContext"
import {
  BadgeElementProvider,
} from "./contexts/BadgeElementContext"
import {
  BadgeDataProvider,
} from "./contexts/BadgeDataContext"

type BadgeBuilderProviderProps = {
  guestData?: GuestData
  eventData?: EventData
  children: React.ReactNode
}

/**
 * BadgeBuilderProvider
 *
 * Composes all BadgeBuilder contexts into a single provider.
 * Components should use specific context hooks:
 * - useBadgeTemplate() for template state
 * - useBadgeSelection() for selection state
 * - useBadgeElement() for element operations
 * - useBadgeData() for guestData/eventData
 */
const BadgeBuilderProvider = ({
  guestData,
  eventData,
  children,
}: BadgeBuilderProviderProps) => (
  <BadgeDataProvider guestData={guestData} eventData={eventData}>
    <BadgeSelectionProvider>
      <BadgeElementProvider>
        {children}
      </BadgeElementProvider>
    </BadgeSelectionProvider>
  </BadgeDataProvider>
)

export default BadgeBuilderProvider
